<template>
  <div style='background:white;' class='' v-loading='loading'>


    <div v-show="true" class='gPageBorder gTopMg'>
      <div style='display:inline-block;width:calc(100% - 48px);height:100%;margin-bottom:0px;background:none;padding:0 0px 12px 24px'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{detail ? detail.configName : ''}}</button>
        </div>
        <div style='height:22px;'>
          <table class='lcpush'>
            <tr>
              <td style="width: 25%;">
                <label class='dt-word-title'>{{$t('lin_global.fwqdizhi')}}：</label>
                <label class='dt-word-main'>{{detail? detail.address : ''}}</label>
              </td>
              <td style="width: 25%;">
                <label class='dt-word-title'>{{$t('app_port')}}：</label>
                <label class='dt-word-main'>{{detail? detail.port : ''}}</label>
              </td>
              <td style="width: 25%;">
                <label class='dt-word-title'>{{$t('app_addtime')}}：</label>
                <label class='dt-word-main'>{{detail? detail.createTime : ''}}</label>
              </td>   
              <td style="width: 25%;">                
              </td>                          
            </tr>
            
          </table>
        </div>
       
      </div>
    </div>

    <div class='gPageBorder gTopMg' v-show="true" style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_fludlist')}} </p>

      <el-row>
        <el-col :span='16'>
          <div class='gSgLeftBtn'>
            <el-button  v-show="true"  @click="addTer" type='primary'  class=''>{{$t('terminal.list.add_btn')}}</el-button>
            <el-button  @click="getList" type='primary'  class=''>{{$t('lin_global.shuaxin')}}</el-button>
          </div>
        </el-col>


        <!-- <el-col :span="4">
            <div class='gCtrl'>
              <el-select  v-model="bindVl" clearable :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in bindSts"
                  :key="item.vl"
                  :label="item.lb"
                  :value="item.vl">
                </el-option>
              </el-select>
            </div>
          </el-col> -->

        <el-col :span="4">
            <div class='gCtrl'>
              <!-- <el-select  v-model="appType" clearable :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in appTypes"
                  :key="item.appClassifyId"
                  :label="item.appClassifyName"
                  :value="item.appClassifyId">
                </el-option>
              </el-select> -->
              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
          </el-col>
            

          <el-col :span="4">
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_name') + ' & ' + $t('app_number')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>
      </el-row>

      
      
      <el-table
        :data="hiss"
        border
        class='gTopMg'
        style="width: 100%;">
        <el-table-column
          header-align='center'
          align='center'
          prop="terminalName"
          :label="$t('app_deviceName')"
          width="">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="terminalNo"
          width=''
          :label="$t('app_deviceNo')">
        </el-table-column>


        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="status"
          width='115'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <label :style='getStatus(scope.row.status).style'>{{getStatus(scope.row.status).vl}}</label>
          </template>
        </el-table-column> -->


        <el-table-column
          header-align='center'
          align='center'
          prop="mechName"
          width=''
          :label="$t('app_distributor')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="version"
          :formatter="showBindSt"
          width=''
          :label="$t('app_status')">
        </el-table-column>
       
        <!-- <el-table-column
          header-align='center'
          align='center'
          fformatter="dateFormat"
          prop="opeTime"
          width='170'
          :label="$t('app_applytime')">
        </el-table-column> -->

        <el-table-column
          header-align='center'
          align='center'
          prop=""
          width='86'
          :label="$t('app_operate')">
          <template slot-scope='scope' >
            

            

            <!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top" v-show='scope.row.status != 1'>
              <el-button type='text' @click='unbind(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" :content="$t('lin_global.chongtui')" placement="top">
              <el-button type='text' v-show='scope.row.status == 0' @click='repushRow(scope.row)'><i class="fa fa-repeat" style=""></i></el-button>
            </el-tooltip>

       


          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style='gPgDiv'>

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSize"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
        </el-pagination>

      </div>
    </div>
  
    <pushdia :pObj='pconfig'></pushdia>
  </div>
</template>

<style>
  .lcpush table td {width: 25%;}
  .dt-word-main{color:rgb(72,87,106)}
  .dt-word-title{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }


 
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  import df from '../../../assets/df.png'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import pushdia from '@/components/system/ptask/pushdia.vue'
  export default {
    data () {
      var _this = this
      return {
        mechanismData: {
          callback (value) {
            _this.mech = value
            // that.selectChange(value)
            _this.getList()
          }
        },
        pconfig: {},
        cfid: '',
        mech: '',
        srchValue: '',
        detail: '',
        dialogVisible: false,
        bindSt: {
          '0': this.$t('app_fail'),
          '1': this.$t('app_success')
        },
        bindVl: '',
        config: '',
        captures: [],
        loading: 0,
        tableData: [],
        tags: [],
        page: 1,
        index:1,
        hiss: [],
        pageTotal: 0
      }
    },
    components: {
      MechanismSelector,pushdia
    },
    computed: {
    
      showUploadNew () {
        //console.log('ccc', this.config.data)
        if (this.config) {
          if (this.config.isoperate === 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      repushRow (row) {
        this.loading = true
        this.$repushFailSyscf(row.id, res => {
          this.loading = false
          if (res.status == 200) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = false
        }) 
      },
      editCf () {
        this.$setWObj('keyEdit', {type: 1, data: this.config, isSetLc: true})
        this.$router.push({path: '/keyrule/detail/edit'})
      },
      showBindSt (row) {
        return this.bindSt[row.status]
      },
      bindOp (row) {
        this.loading = 1
        this.$keyAddDevice(row.terminalId, this.config.id, res => {
          this.loading = 0
          if (res.status === 200) {
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        }) 
      },
      query () {
        this.getList()
      },
      srchDevice () {
        this.getDevices()
      },     
      addTer () {
        var _this = this
        this.pconfig = {
          type: 1, /// 0 task 1 sysconfig
          configId: this.cfid,
          // taskId: row.taskId,
          // taskType: row.taskType,
          close: () => {
            _this.pconfig = ''
            _this.getList()
          }
        }
      },
      deleteApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          console.log(obj)
          this.$delFstRecord(obj.id, (res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      unbind (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          
          this.$delSyscfBindDv(row.id, (res) => {
            if (res.status == 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      editApp (row) {
        this.$setWObj('filestEdit', {type: 1, data: row})
        this.$router.push({path: '/keyrule/detail/edit'})
      },
     
      getList () {
        this.loading = 1
        var mech = this.mech?this.mech:'' //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        // var status = this.bindVl

        this.$syscfBindlist(this.cfid,this.page, this.$gRow, name, mech, res => { 
          this.loading = 0
          if (res.status === 200) {
            this.pageTotal = res.total
            this.hiss = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      getDetail () {
        this.loading = 1        
        this.$syscfDetail(this.cfid, (res) => {          
          this.loading = 0
          if (res.status === 200) {
            this.detail = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {        
        this.getList()
      },
      pageSelect (index) {
        this.page = index
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
     


      delHis (row) {
        
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = 1

          this.$delLauncherHistory(row.versionid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          
        }).catch(() => {
        })
        
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
          //return path
        } else {
          return ''
        }
      },
      uploadNew () {
        // this.$t('menu.sysManageSub.launchNewVer')
        var obj = {type: 2, data: this.config}
        var key = 'launcherEdit'
        this.$setWObj(key, obj)
        this.$router.push({path: '/launch-newver'})
      }
     
    },
    mounted () {
      this.cfid = this.$route.query.id
      this.getDetail()      
      this.getList()
    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?749e09c8